export const Cromados = [
    { name: 'cromados_IXGOLD', value: 'GOLD', imgUrl: 'assets/img/exterior/GOLD.jpg' },
    { name: 'cromados_IXSILVER', value: 'SILVER', imgUrl:'assets/img/exterior/SILVER.jpg' }
]
